import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, OnInit, Output, signal } from '@angular/core';
import { FaqDrill, FaqItem } from '@coin/shared/core/util-models';

import { MatBadgeModule } from '@angular/material/badge';
import { AuthService } from '@coin/shared/auth/data-access';

@Component({
  selector: 'coin-siemens-energy-faq-top-level',
  templateUrl: './faq-top-level.component.html',
  styleUrls: ['./faq-top-level.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatBadgeModule]
})
export class FaqTopLevelComponent implements OnInit {
  authService = inject(AuthService);

  @Input() items: FaqItem[];
  @Output() openFaq = new EventEmitter<FaqDrill>();
  @Output() openOther = new EventEmitter<{ title: string }>();

  private isAuthenticated = signal(false);

  async ngOnInit(): Promise<void> {
    this.isAuthenticated.set(this.authService.isAuthenticated$.value);
  }

  public authRequired(item: FaqItem): boolean {
    return item.requiresAuthentication ? this.isAuthenticated() : true;
  }

  public openFaqItem(content: FaqItem, level: number, title?: string): void {
    if (content.special && content.isSpecial) {
      this.openOther.emit({ title: content.special });
    } else {
      this.openFaq.emit({ content, level, moreWidth: false, title, subtitle: undefined });
    }
  }
}
